module.exports = __webpack_public_path__ + "static/img/home1.321379d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/home1.jpg
// module id = DekZ
// module chunks = 1